<template>
  <router-view />
</template>

<script>
import api from '@/api';
import store from '@/store';
import router from '@/router';

export default {
  name: "App",
  mounted() {
    this.checkStatusInterval = setInterval(async () => {
      const user = JSON.parse(localStorage.getItem('user'));

      if (!user) return; // pas connecté

      try {

        //  Vérifier l’état du compte via l’API
        const response = await api.getItem("users", user.id);
        const freshUser = response.data;

        if (!freshUser.enabled) {
          //  Déconnexion + redirection
          
          store.commit('logout');
          router.push({ 
            path: '/login',
            query: { message: 'Votre compte a été désactivé.' }
          });
        }

      } catch (error) {
        console.error("Erreur vérification status utilisateur :", error);
      }

    }, 50000); // toutes les 50 secondes
  },

  unmounted() {
    clearInterval(this.checkStatusInterval);
  }
};
</script>

